/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ErrorResult,
  JustPortfolioDeleteViewModel,
  JustPortfolioViewModel,
  NotFoundErrorResult,
  Result,
  ResultOfJustPortfolioViewModel,
  ValidationErrorResult,
} from '../models';
import {
    ErrorResultFromJSON,
    ErrorResultToJSON,
    JustPortfolioDeleteViewModelFromJSON,
    JustPortfolioDeleteViewModelToJSON,
    JustPortfolioViewModelFromJSON,
    JustPortfolioViewModelToJSON,
    NotFoundErrorResultFromJSON,
    NotFoundErrorResultToJSON,
    ResultFromJSON,
    ResultToJSON,
    ResultOfJustPortfolioViewModelFromJSON,
    ResultOfJustPortfolioViewModelToJSON,
    ValidationErrorResultFromJSON,
    ValidationErrorResultToJSON,
} from '../models';

export interface JustPortfolioDeleteRequest {
    proposalId: number;
    justPortfolioDeleteViewModel: JustPortfolioDeleteViewModel;
}

export interface JustPortfolioGetRequest {
    proposalId: number;
}

export interface JustPortfolioPostRequest {
    proposalId: number;
    justPortfolioViewModel: JustPortfolioViewModel;
}

/**
 * 
 */
export class JustPortfolioApi extends runtime.BaseAPI {

    /**
     * Deletes the just portfolio for a proposal.
     */
    async justPortfolioDeleteRaw(requestParameters: JustPortfolioDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Result>> {
        if (requestParameters.proposalId === null || requestParameters.proposalId === undefined) {
            throw new runtime.RequiredError('proposalId','Required parameter requestParameters.proposalId was null or undefined when calling justPortfolioDelete.');
        }

        if (requestParameters.justPortfolioDeleteViewModel === null || requestParameters.justPortfolioDeleteViewModel === undefined) {
            throw new runtime.RequiredError('justPortfolioDeleteViewModel','Required parameter requestParameters.justPortfolioDeleteViewModel was null or undefined when calling justPortfolioDelete.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/v2/just-portfolio/{proposalId}`.replace(`{${"proposalId"}}`, encodeURIComponent(String(requestParameters.proposalId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: JustPortfolioDeleteViewModelToJSON(requestParameters.justPortfolioDeleteViewModel),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultFromJSON(jsonValue));
    }

    /**
     * Deletes the just portfolio for a proposal.
     */
    async justPortfolioDelete(requestParameters: JustPortfolioDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Result> {
        const response = await this.justPortfolioDeleteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Gets the just portfolio for a proposal.
     */
    async justPortfolioGetRaw(requestParameters: JustPortfolioGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResultOfJustPortfolioViewModel>> {
        if (requestParameters.proposalId === null || requestParameters.proposalId === undefined) {
            throw new runtime.RequiredError('proposalId','Required parameter requestParameters.proposalId was null or undefined when calling justPortfolioGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/v2/just-portfolio/{proposalId}`.replace(`{${"proposalId"}}`, encodeURIComponent(String(requestParameters.proposalId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultOfJustPortfolioViewModelFromJSON(jsonValue));
    }

    /**
     * Gets the just portfolio for a proposal.
     */
    async justPortfolioGet(requestParameters: JustPortfolioGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResultOfJustPortfolioViewModel> {
        const response = await this.justPortfolioGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Updates the just portfolio for a proposal.
     */
    async justPortfolioPostRaw(requestParameters: JustPortfolioPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Result>> {
        if (requestParameters.proposalId === null || requestParameters.proposalId === undefined) {
            throw new runtime.RequiredError('proposalId','Required parameter requestParameters.proposalId was null or undefined when calling justPortfolioPost.');
        }

        if (requestParameters.justPortfolioViewModel === null || requestParameters.justPortfolioViewModel === undefined) {
            throw new runtime.RequiredError('justPortfolioViewModel','Required parameter requestParameters.justPortfolioViewModel was null or undefined when calling justPortfolioPost.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/v2/just-portfolio/{proposalId}`.replace(`{${"proposalId"}}`, encodeURIComponent(String(requestParameters.proposalId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: JustPortfolioViewModelToJSON(requestParameters.justPortfolioViewModel),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultFromJSON(jsonValue));
    }

    /**
     * Updates the just portfolio for a proposal.
     */
    async justPortfolioPost(requestParameters: JustPortfolioPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Result> {
        const response = await this.justPortfolioPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
